<template>
  <div>
    <select
      class="bg-white border border-secondary-500 px-4 py-3 w-full max-w-sm rounded"
      v-bind="$attrs"
      @change="$emit('update', $event.target.value)"
      v-on="$listeners"
    >
      <option :value="defaultValue" class="p-24">{{ defaultText }}</option>
      <option
        v-for="option in optionList"
        :key="option.id"
        :value="option.id"
        :selected="option.selected"
      >
        {{ option.text }}
      </option>
    </select>

    <BaseInputError v-if="v.$error && v.$invalid" class="w-64">
      Este campo es obligatorio
    </BaseInputError>

    <BaseInputError v-if="serverErrors[name]" class="w-64">
      {{ serverErrors[name][0] }}
    </BaseInputError>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    defaultValue: {
      type: [String, Number],
      required: false,
      default: '',
    },
    defaultText: {
      type: String,
      required: true,
    },
    optionList: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('forms', ['serverErrors']),
  },
}
</script>
